import { Stack, Typography } from "@mui/material";

export default function OutstandingCredits(){

    return (
        <Stack spacing={2} sx={{textAlign: 'center', backgroundColor: '#eaf7f4', borderRadius: '5px', p: 2}}>

            <Typography variant="h6">
                ✔️ <b>Votre inscription a bien été prise en compte !</b>
            </Typography>

            <Typography>
                Bonne nouvelle, il vous reste des crédits de formation.
                <br/>
                Inscrivez-vous dès maintenant à une seconde formation 100% prise en charge pour obtenir votre récompense. 🎁
            </Typography>

        </Stack>
    );
}